<div class="tw-flex tw-flex-col tw-h-full tw-max-h-[80vh]">
  <!-- Header -->
  <div
    class="tw-flex tw-items-center tw-justify-between tw-p-6 tw-border-b tw-border-slate-200 dark:tw-border-slate-700">
    <div class="tw-flex tw-items-center tw-gap-3">
      <div
        class="tw-w-10 tw-h-10 tw-bg-gradient-to-r tw-from-indigo-500 tw-to-purple-600 tw-rounded-full tw-flex tw-items-center tw-justify-center">
        <ng-icon name="heroUsers" size="20" class="tw-text-white"></ng-icon>
      </div>
      <div>
        <h2 class="tw-text-xl tw-font-semibold tw-text-slate-900 dark:tw-text-slate-100">
          Connection Requests
        </h2>
        <p class="tw-text-sm tw-text-slate-500 dark:tw-text-slate-400 tw-mb-0">
          Manage your incoming connection requests
        </p>
      </div>
    </div>

    <button (click)="onClose()"
      class="tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-text-slate-400 hover:tw-text-slate-600 dark:hover:tw-text-slate-300 hover:tw-bg-slate-100 dark:hover:tw-bg-slate-700 tw-transition-colors tw-duration-200">
      <ng-icon name="heroXMark" size="20"></ng-icon>
    </button>
  </div>

  <!-- Filters and Search -->
  <div
    class="tw-p-4 tw-border-b tw-border-slate-200 dark:tw-border-slate-700 tw-bg-slate-50/50 dark:tw-bg-slate-800/50">
    <div class="tw-flex tw-flex-col sm:tw-flex-row tw-gap-3">
      <!-- Search -->
      <div class="tw-flex-1 tw-relative">
        <div class="tw-absolute tw-left-3 tw-top-1/2 tw-transform tw--translate-y-1/2">
          <ng-icon name="heroMagnifyingGlass" size="16" class="tw-text-slate-400"></ng-icon>
        </div>
        <input type="text" [(ngModel)]="searchQuery" (input)="updateSearch()" placeholder="Search by name or company..."
          class="tw-w-full tw-pl-10 tw-pr-4 tw-py-2.5 tw-bg-white dark:tw-bg-slate-800 tw-border tw-border-slate-200 dark:tw-border-slate-700 tw-rounded-xl tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/20 focus:tw-border-indigo-400">
      </div>

      <!-- Filter Tabs -->
      <div
        class="tw-flex tw-bg-white dark:tw-bg-slate-800 tw-border tw-border-slate-200 dark:tw-border-slate-700 tw-rounded-xl tw-p-1">
        <button *ngFor="let filter of filterOptions" (click)="setActiveFilter(filter.value)"
          [class]="getFilterButtonClass(filter.value)"
          class="tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-rounded-lg tw-transition-all tw-duration-200">
          {{ filter.label }}
          <span class="tw-ml-1.5 tw-px-1.5 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-bold"
            [class]="getFilterBadgeClass(filter.value)">
            {{ getFilterCount(filter.value) }}
          </span>
        </button>
      </div>
    </div>
  </div>

  <!-- Content -->
  <div class="tw-flex-1 tw-overflow-y-auto tw-p-4">
    <div class="tw-space-y-4">
      @for (request of filteredRequests(); track request._id) {
      <div
        class="tw-group tw-relative tw-p-4 tw-bg-white dark:tw-bg-slate-800 tw-border tw-border-slate-200 dark:tw-border-slate-700 tw-rounded-2xl tw-transition-all tw-duration-300 hover:tw-shadow-lg hover:tw-shadow-slate-200/50 dark:hover:tw-shadow-slate-900/50 hover:tw-scale-[1.01]">

        <div class="tw-flex tw-items-start tw-gap-4">
          <!-- Avatar -->
          <div class="tw-relative tw-flex-shrink-0">
            <app-user-avatar [pictureKey]="request.fromUser.profilePictureKey"
              [pictureTransform]="request.fromUser.pictureTransform" [pictureID]="request.fromUser._id"
              imgClass="tw-w-14 tw-h-14 tw-object-cover tw-rounded-full tw-ring-2 tw-ring-white dark:tw-ring-slate-800 tw-shadow-lg">
            </app-user-avatar>

            <!-- Status Badge -->
            <div class="tw-absolute -tw-bottom-1 -tw-right-1">
              <div
                class="tw-w-6 tw-h-6 tw-rounded-full tw-border-2 tw-border-white dark:tw-border-slate-800 tw-flex tw-items-center tw-justify-center"
                [ngClass]="{
                         'tw-bg-amber-500': request.status === 'pending',
                         'tw-bg-green-500': request.status === 'accepted',
                         'tw-bg-red-500': request.status === 'rejected'
                       }">
                <ng-icon [name]="getStatusIcon(request.status)" size="14" class="tw-text-white">
                </ng-icon>
              </div>
            </div>
          </div>

          <!-- Content -->
          <div class="tw-flex-1 tw-min-w-0">
            <div class="tw-flex tw-items-start tw-justify-between tw-gap-3 tw-mb-2">
              <div>
                <h3 class="tw-text-lg tw-font-semibold tw-text-slate-900 dark:tw-text-slate-100">
                  {{ request.fromUser.firstName }} {{ request.fromUser.lastName }}
                </h3>
              </div>

              <div class="tw-text-right">
                <span class="tw-text-sm tw-text-slate-500 dark:tw-text-slate-400">
                  {{ request.createdAt | timeAgo }}
                </span>
                <div
                  class="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-2 tw-py-1 tw-rounded-full tw-text-xs tw-font-medium tw-mt-1"
                  [ngClass]="{
                        'tw-bg-amber-100 dark:tw-bg-amber-900/20 tw-text-amber-700 dark:tw-text-amber-400': request.status === 'pending',
                        'tw-bg-green-100 dark:tw-bg-green-900/20 tw-text-green-700 dark:tw-text-green-400': request.status === 'accepted',
                        'tw-bg-red-100 dark:tw-bg-red-900/20 tw-text-red-700 dark:tw-text-red-400': request.status === 'rejected'
                      }">
                  <ng-icon [name]="getStatusIcon(request.status)" size="12"></ng-icon>
                  <span>{{ getStatusLabel(request.status) }}</span>
                </div>
              </div>
            </div>

            @if (request.message) {
            <div class="tw-p-3 tw-bg-slate-50 dark:tw-bg-slate-700/50 tw-rounded-xl tw-mb-4">
              <p class="tw-text-sm tw-text-slate-600 dark:tw-text-slate-300 tw-leading-relaxed tw-mb-0">
                "{{ request.message }}"
              </p>
            </div>
            }

            <!-- Actions for pending requests -->
            @if (request.status === 'pending') {
            <div class="tw-flex tw-items-center tw-gap-3">
              <!-- Accept Button -->
              <button (click)="onAcceptRequest(request)" [disabled]="acceptingRequest || rejectingRequest"
                class="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2.5 tw-bg-gradient-to-r tw-from-green-500 tw-to-green-600 hover:tw-from-green-600 hover:tw-to-green-700 tw-text-white tw-text-sm tw-font-medium tw-rounded-xl tw-transition-all tw-duration-200 hover:tw-scale-105 tw-active:scale-95 tw-shadow-lg tw-shadow-green-500/25 disabled:tw-opacity-70 disabled:tw-cursor-not-allowed disabled:hover:tw-scale-100">

                @if (acceptingRequest) {
                <!-- Loading spinner -->
                <div
                  class="tw-w-4 tw-h-4 tw-border-2 tw-border-white tw-border-t-transparent tw-rounded-full tw-animate-spin">
                </div>
                <span>Accepting...</span>
                } @else {
                <ng-icon name="heroCheckCircle" size="16"></ng-icon>
                <span>Accept Connection</span>
                }
              </button>

              <!-- Reject Button -->
              <button (click)="onRejectRequest(request)" [disabled]="acceptingRequest || rejectingRequest"
                class="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2.5 tw-bg-slate-100 dark:tw-bg-slate-700 hover:tw-bg-slate-200 dark:hover:tw-bg-slate-600 tw-text-slate-700 dark:tw-text-slate-300 tw-text-sm tw-font-medium tw-rounded-xl tw-transition-all tw-duration-200 hover:tw-scale-105 tw-active:scale-95 disabled:tw-opacity-70 disabled:tw-cursor-not-allowed disabled:hover:tw-scale-100">

                @if (rejectingRequest) {
                <!-- Loading spinner -->
                <div
                  class="tw-w-4 tw-h-4 tw-border-2 tw-border-slate-400 dark:tw-border-slate-400 tw-border-t-transparent tw-rounded-full tw-animate-spin">
                </div>
                <span>Declining...</span>
                } @else {
                <ng-icon name="heroXCircle" size="16"></ng-icon>
                <span>Decline</span>
                }
              </button>
            </div>
            }

          </div>
        </div>
      </div>
      }

      <!-- Empty State -->
      @if (filteredRequests().length === 0) {
      <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-16 tw-text-center">
        <div
          class="tw-w-20 tw-h-20 tw-bg-gradient-to-br tw-from-slate-100 tw-to-slate-200 dark:tw-from-slate-800 dark:tw-to-slate-700 tw-rounded-3xl tw-flex tw-items-center tw-justify-center tw-mb-6">
          <ng-icon name="heroUsers" size="32" class="tw-text-slate-400 dark:tw-text-slate-500"></ng-icon>
        </div>
        <h3 class="tw-text-lg tw-font-semibold tw-text-slate-900 dark:tw-text-slate-100 tw-mb-2">
          No {{ activeFilter() === 'all' ? '' : activeFilter() }} requests found
        </h3>
        <p class="tw-text-sm tw-text-slate-500 dark:tw-text-slate-400 tw-max-w-sm tw-mb-0">
          @if (searchQuery) {
          Try adjusting your search terms or filters
          } @else {
          Connection requests will appear here when users want to connect with you
          }
        </p>
      </div>
      }
    </div>
  </div>
</div>